import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color} opacity={0.2}>
      <path d='M19 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0M19 17a3 3 0 1 1-6 0 3 3 0 0 1 6 0' />
    </g>
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M16 3a4 4 0 0 0-3.912 4.838L9.017 9.373a4 4 0 1 0 0 5.253l3.07 1.536q-.086.405-.087.838a4 4 0 1 0 .983-2.626l-3.07-1.536a4 4 0 0 0 0-1.676l3.07-1.536A4 4 0 1 0 16 3m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m-8 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareGhost)
export default ForwardRef
